import { HolidayCalendarRoute } from "./routes/HolidayCalendarRoute";

export const HOLIDAY_CALENDAR_ROUTES = {
  holidays: {
    key: "holidays",
    path: "/settings/holidays",
    element: <HolidayCalendarRoute />
  }
};
